import { render, staticRenderFns } from "./NewsMediaEdit.vue?vue&type=template&id=ff25e1b2&lang=pug"
import script from "./NewsMediaEdit.vue?vue&type=script&lang=js"
export * from "./NewsMediaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports